<template>
  <div id="page-product-plan">
    <!-- 主内容区域 -->
    <div class="main-content">
      <!-- 左侧机台列表 -->
      <div class="machine-sidebar">
        <div class="machine-search">
          <Input
            placeholder="请输入机台号"
            v-model.trim="machineSidebarParam.machineNo"
            @keyup.enter.native="getMachineSidebarList"
            style="width: 100%"
          />
        </div>
        <Table
          max-height="600"
          :loading="machineSidebarLoading"
          :columns="machineSidebarColumns"
          :data="machineSidebarData"
          @on-row-click="handleMachineRowClick"
        >
        </Table>
      </div>

      <!-- 右侧内容 -->
      <div class="right-content">
        <!-- 顶部筛选 -->
        <div class="common-filter-block">
          <div class="common-filter-item">
            <Select v-model="listParam.searchType" style="width: 120px">
              <Option value="1" key="1">胚布指示单号</Option>
              <Option value="2" key="2">合同号</Option>
              <Option value="3" key="3">客户名称</Option>
            </Select>
            <Input
              placeholder="请输入搜索内容"
              v-model.trim="listParam.searchText"
              @keyup.enter.native="getTableListData"
              style="width: 200px"
            />
          </div>
          <div class="common-filter-item">
            <span style="margin-right: 10px">胚布货号</span>
            <Input
              placeholder="请输入搜索内容"
              v-model.trim="listParam.greyClothGoodsNo"
              @keyup.enter.native="getTableListData"
              style="width: 180px"
            />
          </div>
          <div class="common-filter-item">
            <span style="margin-right: 10px">机台号</span>
            <Input
              placeholder="请输入搜索内容"
              v-model.trim="listParam.machineNo"
              @keyup.enter.native="getTableListData"
              style="width: 180px"
            />
          </div>
          <div class="common-filter-item">
            <Button type="primary" @click="getTableListData" style="margin-right: 10px">筛选</Button>
            <Button @click="resetForm">重置</Button>
          </div>
        </div>

        <!-- 自定义的表格操作栏 -->
        <div class="common-action-block">
          <Button type="primary" style="margin-right: 10px" @click="openAddModal">新增</Button>
          <Button type="error" style="margin-right: 10px" @click="cancelProduction">删除</Button>
          <Button @click="exportProductPlanList">导出</Button>
        </div>

        <!-- 表格 -->
        <Table
          ref="selection"
          border
          :loading="loading"
          :columns="tableColumns"
          :data="tableData"
          :row-class-name="bindFailRowClass"
          @on-selection-change="selectionChange"
        >
      <template slot-scope="{ row, index }" slot="action">
        <span
          v-if="row.status === 1"
          style="color: #256de6; cursor: pointer"
          @click="clickProductPlan(row, index, 'add')"
          >排产</span
        >
        <span
          v-else
          style="color: #256de6; cursor: pointer"
          @click="openEditModal(row, index)"
          >修改</span
        >
      </template>
      <template slot-scope="{ row }" slot="predictStartDate">
        {{ row.predictStartDate }}
        <Poptip trigger="click" :transfer="true" padding="16px 24px">
          <i
            v-if="checkOvertime(row.predictStartDate)"
            style="color: #f94040"
            class="iconfont iconicon-tishi"
          ></i>
          <span style="color: #f94040" slot="content">当前日期已超过预计开工日期</span>
        </Poptip>
      </template>
      <template slot-scope="{ row }" slot="greyClothSheetNo">
        <span style="color: #256de6; cursor: pointer" @click="goToDetailPage(row)">{{
          row.greyClothSheetNo
        }}</span>
      </template>
        </Table>
        <!-- 分页 -->
        <Page
          class-name="common-page"
          show-sizer
          show-elevator
          show-total
          :total="listDataTotal"
          :page-size="listParam.pageSize"
          :current="listParam.pageNum"
          @on-page-size-change="pageSizeChange"
          @on-change="pageNumberChange"
        />
      </div>
    </div>

    <!-- 排产安排弹窗 -->
    <Modal
      class="product-plan-modal"
      v-model="isShowProductPlanModal"
      title="排产"
      @on-visible-change="modalVisibleChange"
    >
      <div slot="footer">
        <Button type="text" size="large" @click="isShowProductPlanModal = false">取消</Button>
        <Button type="primary" size="large" @click="submitProductPlan('greyClothPlanOrderFrom')"
          >确定</Button
        >
      </div>

      <Spin size="large" fix v-if="spinShow"></Spin>
      <div class="top">
        <Row style="margin-bottom: 8px">
          <Col span="10"> 胚布指示单号：{{ greyClothPlanOrderInfo.weaveDetail }} </Col>
          <Col span="10" offset="4"> 合同号：{{ greyClothPlanOrderInfo.ztgcpoContractNo }} </Col>
        </Row>
        <Row style="margin-bottom: 8px">
          <Col span="24"> 胚布货号：{{ greyClothPlanOrderInfo.ztgcpoGreyClothItemNo }} </Col>
        </Row>

        <Row style="margin-bottom: 8px">
          <Col span="10"> 客户名称：{{ greyClothPlanOrderInfo.ztgcpoCustomer }} </Col>
          <Col span="10" offset="4"> 客户款号：{{ greyClothPlanOrderInfo.ztgcpoiClientNum }} </Col>
        </Row>
        <Row style="margin-bottom: 8px">
          <Col span="10"> 计划匹重：{{ greyClothPlanOrderInfo.ztgcpoiClothWeight }} </Col>
          <Col span="10" offset="4">
            订单需求数：{{ greyClothPlanOrderInfo.ztgcpoiOrderDemandNum }}
          </Col>
        </Row>
      </div>
      <div class="bottom">
        <Form
          :label-width="120"
          label-position="right"
          ref="greyClothPlanOrderFrom"
          :model="greyClothPlanOrderInfo"
          :rules="greyClothPlanOrderRule"
        >
          <FormItem label="计划匹数" prop="ztgcpoiClothNum"
            ><Input v-model="greyClothPlanOrderInfo.ztgcpoiClothNum"
          /></FormItem>
          <FormItem label="计划数" prop="ztgcpoiPlanNum"
            ><Input v-model="greyClothPlanOrderInfo.ztgcpoiPlanNum"
          /></FormItem>
          <FormItem label="计划下发时间" prop="ztppTransferOrderDate"
            ><el-date-picker
              style="width: 100%"
              v-model="greyClothPlanOrderInfo.ztppTransferOrderDate"
              type="datetime"
              placeholder="选择日期时间"
              default-time="07:30:00"
              @on-change="handleTransferOrderDateChange"
            >
            </el-date-picker>
          </FormItem>
          <FormItem label="预计开工日期" prop="rawPlanStartDate">
            <DatePicker
              style="width: 100%"
              type="date"
              placeholder="请选择日期"
              v-model="greyClothPlanOrderInfo.rawPlanStartDate"
              @on-change="handlePlanStartDateChange"
            ></DatePicker>
          </FormItem>
          <FormItem label="预计完工日期" prop="rawPlanEndDate">
            <DatePicker
              style="width: 100%"
              type="date"
              placeholder="请选择日期"
              v-model="greyClothPlanOrderInfo.rawPlanEndDate"
              @on-change="handlePlanEndDateChange"
            ></DatePicker
          ></FormItem>
          <FormItem label="选择机台" prop="ztppMachineNoList">
            <Tag
              closable
              size="large"
              v-for="item in greyClothPlanOrderInfo.ztppMachineNoList"
              :key="item.machineNo"
              :name="item.machineNo"
              :class="{ 'tag-fail': item.transferOrderStatus == 3 }"
              @on-close="removeMachineTag"
              >{{ item.machineNo }}</Tag
            >
            <Button icon="ios-add-circle-outline" type="text" @click="clickSelectMachine"
              >添加机台</Button
            ></FormItem
          >
          <FormItem label="备注" prop="ztppRemark"
            ><Input type="textarea" v-model="greyClothPlanOrderInfo.ztppRemark"
          /></FormItem>
        </Form>
      </div>
    </Modal>

    <!-- 客户选择弹窗 -->
    <Modal
      class="select-customer-modal"
      :width="860"
      v-model="isShowCustomerModal"
      title="选择客户"
    >
      <div style="margin-bottom: 20px">
        <Input
          placeholder="请输入客户名称"
          v-model="customerPage.customerName"
          @keyup.enter.native="searchCustomer(customerPage.customerName)"
        >
          <Button slot="append" @click="searchCustomer(customerPage.customerName)">搜索</Button>
        </Input>
      </div>
      <Table
        max-height="400"
        :loading="customerLoading"
        :columns="customerTableColumns"
        :data="customerList"
        @on-row-click="submitCustomerSelect"
      >
      </Table>
      <Page
        class-name="common-page"
        show-sizer
        show-elevator
        show-total
        :total="customerListTotal"
        :page-size="customerPage.pageSize"
        :current="customerPage.pageNum"
        @on-page-size-change="customerPageSizeChange"
        @on-change="customerPageNumberChange"
      />
    </Modal>

    <!-- 合同号选择弹窗 -->
    <Modal
      class="select-contract-modal"
      :width="860"
      v-model="isShowContractModal"
      title="选择合同"
    >
      <div style="margin-bottom: 20px">
        <span style="margin-right: 10px">客户名称：</span>
        <span style="font-weight: bold">{{ addForm.customerName }}</span>
      </div>
      <div style="margin-bottom: 20px; display: flex; gap: 10px;">
        <Input
          placeholder="请输入合同号"
          v-model="contractSearchParam.ztgcpoContractNo"
          style="width: 200px"
        />
        <Input
          placeholder="请输入胚布指示单号"
          v-model="contractSearchParam.greyClothSheetNo"
          style="width: 200px"
        />
        <Button type="primary" @click="searchContract">搜索</Button>
        <Button @click="resetContractSearch">重置</Button>
      </div>
      <Table
        max-height="350"
        :loading="contractLoading"
        :columns="contractTableColumns"
        :data="contractList"
        @on-row-click="submitContractSelect"
      >
      </Table>
      <Page
        class-name="common-page"
        show-sizer
        show-elevator
        show-total
        :total="contractListTotal"
        :page-size="contractPage.pageSize"
        :current="contractPage.pageNum"
        @on-page-size-change="contractPageSizeChange"
        @on-change="contractPageNumberChange"
      />
    </Modal>

    <!-- 新增排产的机台选择弹窗 -->
    <Modal
      class="select-machine-modal add-machine-modal"
      :width="860"
      v-model="isShowAddMachineModal"
      title="选择机台"
      @on-ok="submitAddMachineSelect"
      @on-visible-change="subModalVisibleChange"
    >
      <!-- 机台表格的筛选部分 -->
      <Row style="margin-bottom: 20px" :gutter="20" justify="space-between">
        <Col span="8">
          <Input
            style="min-width: 200px"
            placeholder="通过机台号搜索"
            v-model.trim="machineListParam.param.machineNo"
            @input="getMachineTableListData"
          />
        </Col>
        <Col span="8">
          <Input
            placeholder="通过货号搜索"
            v-model.trim="machineListParam.param.greyClothItemNo"
            @input="getMachineTableListData"
          />
        </Col>
        <Col span="6"
          ><div style="display: flex; align-items: center; white-space: nowrap">
            <span style="padding-right: 10px">状态</span>
            <Select v-model="machineListParam.param.status" @on-change="getMachineTableListData">
              <Option v-for="item in deviceStatusList" :value="item.value" :key="item.value">{{
                item.label
              }}</Option>
            </Select>
          </div>
        </Col>
      </Row>
      <div class="selectedMachineRow">
        已选择机台
        <span style="color: #256de6; margin-left: 10px">{{ selectedDeviceIdList.filter(id => id).join("、") }}</span>
      </div>
      <Table
        max-height="480"
        ref="selection"
        :loading="machineLoading"
        :columns="machineTableColumns"
        :data="machineTableData"
        @on-selection-change="machineSelectionChange"
      >
      </Table>
    </Modal>

    <!-- 选择机台弹窗 -->
    <Modal
      class="select-machine-modal"
      :width="860"
      v-model="isShowselectMachineModal"
      title="选择机台"
      @on-ok="submitSelectMachine"
      @on-visible-change="subModalVisibleChange"
    >
      <!-- 机台表格的筛选部分 -->
      <Row style="margin-bottom: 20px" :gutter="20" justify="space-between">
        <Col span="8">
          <Input
            style="min-width: 200px"
            placeholder="通过机台号搜索"
            v-model.trim="machineListParam.param.machineNo"
            @input="getMachineTableListData"
          />
        </Col>
        <Col span="8">
          <Input
            placeholder="通过货号搜索"
            v-model.trim="machineListParam.param.greyClothItemNo"
            @input="getMachineTableListData"
          />
        </Col>
        <Col span="6"
          ><div style="display: flex; align-items: center; white-space: nowrap">
            <span style="padding-right: 10px">状态</span>
            <Select v-model="machineListParam.param.status" @on-change="getMachineTableListData">
              <Option v-for="item in deviceStatusList" :value="item.value" :key="item.value">{{
                item.label
              }}</Option>
            </Select>
          </div>
        </Col>
      </Row>
      <div class="selectedMachineRow">
        已选择机台
        <span style="color: #256de6; margin-left: 10px">{{ selectedDeviceIdList.filter(id => id).join("、") }}</span>
      </div>
      <Table
        max-height="480"
        ref="selection"
        :loading="machineLoading"
        :columns="machineTableColumns"
        :data="machineTableData"
        @on-selection-change="machineSelectionChange"
      >
      </Table>
    </Modal>

    <!-- 新增/修改排产弹窗 -->
    <Modal
      v-model="isShowAddModal"
      :title="addModalTitle"
      width="800"
      @on-visible-change="addModalVisibleChange"
    >
      <div slot="footer">
        <Button @click="isShowAddModal = false">取消</Button>
        <Button type="primary" style="margin-right: 10px" @click="saveAddForm('add')">保存</Button>
        <Button type="primary" @click="saveAddForm('saveAndSend')">保存并下发</Button>
      </div>
      
      <Form
        ref="addForm"
        :model="addForm"
        :rules="addFormRules"
        label-width="100"
      >
        <Row :gutter="20">
          <Col span="24">
            <FormItem label="机台选择" prop="machineNo">
              <div class="pseudo-input" @click="openMachineSelectModal">
                <span v-if="addForm.machineNo">{{ addForm.machineNo }}</span>
                <span v-else class="placeholder">请选择机台</span>
                <i class="iconfont iconicon-xiala"></i>
              </div>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="20">
          <Col span="12">
            <FormItem label="计划下发时间" prop="transferOrderDate">
              <DatePicker
                style="width: 100%"
                type="datetime"
                placeholder="请选择时间"
                v-model="addForm.transferOrderDate"
                format="yyyy-MM-dd HH:mm"
                :options="datePickerOptions"
              ></DatePicker>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="排序置顶">
              <Checkbox v-model="addForm.isSort"></Checkbox>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="20">
          <Col span="12">
            <FormItem label="客户名称" prop="customerName">
              <div class="pseudo-input" @click="openCustomerSelectModal">
                <span v-if="addForm.customerName">{{ addForm.customerName }}</span>
                <span v-else class="placeholder">请选择客户</span>
                <i class="iconfont iconicon-xiala"></i>
              </div>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="合同号" prop="contractNo">
              <div class="pseudo-input" @click="openContractSelectModal" :class="{ 'disabled': !addForm.customerName }">
                <span v-if="addForm.contractNo">{{ addForm.contractNo }}</span>
                <span v-else class="placeholder">{{ addForm.customerName ? '请选择合同' : '请先选择客户' }}</span>
                <i class="iconfont iconicon-xiala"></i>
              </div>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="20">
          <Col span="12">
            <FormItem label="布种编号" prop="clothTypeNo">
              <Input v-model="addForm.clothTypeNo" placeholder="请输入布种编号" />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="布种名称" prop="clothTypeName">
              <Input v-model="addForm.clothTypeName" placeholder="请输入布种名称" />
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="20">
          <Col span="12">
            <FormItem label="织布单价" prop="zhiBuDanJia">
              <Input v-model="addForm.zhiBuDanJia" placeholder="请输入织布单价" />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="计件单价" prop="jiJianDanJia">
              <Input v-model="addForm.jiJianDanJia" placeholder="请输入计件单价" />
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="20">
          <Col span="12">
            <FormItem label="下单条数" prop="orderQuantity">
              <Input v-model="addForm.orderQuantity" placeholder="请输入下单条数" />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="要求匹重" prop="requiredWeight">
              <Input v-model="addForm.requiredWeight" placeholder="请输入要求匹重" />
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="20">
          <Col span="12">
            <FormItem label="下单重量" prop="orderWeight">
              <Input v-model="addForm.orderWeight" placeholder="请输入下单重量" />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="交货时间" prop="deliveryDate">
              <DatePicker
                style="width: 100%"
                type="datetime"
                placeholder="请选择交货时间"
                v-model="addForm.deliveryDate"
                format="yyyy-MM-dd HH:mm"
                :options="datePickerOptions"
              ></DatePicker>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="20">
          <Col span="12">
            <FormItem label="胚布指示单号" prop="greyClothSheetNo">
              <Input v-model="addForm.greyClothSheetNo" placeholder="请输入胚布指示单号" />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="客户款号" prop="customerStyleNo">
              <Input v-model="addForm.customerStyleNo" placeholder="请输入客户款号" />
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="20">
          <Col span="24">
            <FormItem label="备注" prop="remark">
              <Input type="textarea" v-model="addForm.remark" placeholder="请输入备注" :rows="4" />
            </FormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  </div>
</template>

<script>
import { searchTypeList, schedulingStatusList, deviceStatusList } from "./constant";
import {
  fetchProductPlanList,
  fetchSyncTableData,
  // fetchCompleteProduction,
  fetchCancelProduction,
  fetchTransferOrderDetail,
  fetchDeviceList,
  fetchSubmitProductPlan,
  fetchCustomerSearch,
  fetchContractNoByCustomerName
} from "./api";

export default {
  name: "ProductPlan",

  data() {
    return {
      value3: "",
      datePickerOptions: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      },

      currentRowIndex: 0,

      // 表格列表的请求参数
      listParam: {
        searchType: 1, // 1:胚布指示单号,2:合同号,3:客户名称,4:款式（客户款号）
        searchText: "", // 根据searchType填写相应内容
        machineNo: "", // 机台号
        greyClothGoodsNo: "", // 胚布货号
        ifScheduling: 0,
        pageNum: 1,
        pageSize: 10
      },

      // 首页表格配置
      loading: false,
      tableColumns: [
        {
          type: "selection",
          width: 54,
          align: "center",
          // 允许多选
          multiple: true
        },
        {
          title: "序号",
          type: "index",
          width: 66
        },
        {
          title: "操作",
          slot: "action",
          width: 70
        },
        {
          title: "客户名称",
          key: "clientName",
          minWidth: 160
        },
        {
          title: "胚布指示单号",
          slot: "greyClothSheetNo",
          key: "greyClothSheetNo",
          width: 140
        },
        {
          title: "合同号",
          key: "contractNo",
          width: 140
        },
        {
          title: "布种编号",
          key: "buZhongBianHao",
          minWidth: 120
        },
        {
          title: "布种名称",
          key: "buZhongMingCheng",
          minWidth: 120
        },
        {
          title: "织布单价",
          key: "zhiBuDanJia",
          width: 100
        },
        {
          title: "计件单价",
          key: "jiJianDanJia",
          width: 100
        },
        {
          title: "下单条数",
          key: "xiaDanTiaoShu",
          width: 100
        },
        {
          title: "要求匹重",
          key: "yaoQiuPiZhong",
          width: 100
        },
        {
          title: "下单重量",
          key: "xiaDanZhonLiang",
          width: 100
        },
        {
          title: "机台号",
          key: "machineNo",
          width: 80
        },
        {
          title: "计划下发时间",
          key: "transferOrderDate",
          width: 160
        },
        {
          title: "交货时间",
          key: "deliveryDate",
          width: 120
        },
        {
          title: "制单日期",
          key: "createTime",
          width: 120
        },
        // {
        //   title: "胚布货号",
        //   key: "greyClothGoodsNo",
        //   width: 120
        // },
        // {
        //   title: "预计开工日期",
        //   slot: "predictStartDate",
        //   key: "predictStartDate",
        //   width: 140
        // },
        // {
        //   title: "状态",
        //   key: "statusName",
        //   width: 80
        // },
        // {
        //   title: "计划日期",
        //   key: "planDate",
        //   width: 120
        // },
        // {
        //   title: "客户款号",
        //   key: "clientMoneyNo",
        //   minWidth: 140
        // },
        // {
        //   title: "订单需求数",
        //   key: "orderNeedNum",
        //   width: 110
        // },
        // {
        //   title: "计划数(kg)",
        //   key: "ztgcpoiPlanNum",
        //   width: 110
        // },
        // {
        //   title: "计划匹数",
        //   key: "ztgcpoiClothNum",
        //   width: 100
        // },
        // {
        //   title: "计划匹重",
        //   key: "planPieceWeight",
        //   width: 100
        // },
        // {
        //   title: "预计完工日期",
        //   key: "predictFinishDate",
        //   width: 130
        // },
        // {
        //   title: "颜色",
        //   key: "color",
        //   minWidth: 180
        // },
        {
          title: "备注",
          key: "remark",
          minWidth: 180
        }
      ],
      tableData: [],

      listDataTotal: 0, // 分页器数据总条数

      ztppIdList: [], // “纵通” 排产表的id数组

      isShowProductPlanModal: false, // 排产模态框是否显示
      isShowselectMachineModal: false, // 选择机台模态框是否显示
      isShowAddModal: false, // 新增排产模态框是否显示
      addModalTitle: '新增排产', // 新增弹窗标题
      isShowAddMachineModal: false, // 新增排产的机台选择弹窗
      isShowCustomerModal: false, // 客户选择弹窗
      isShowContractModal: false, // 合同号选择弹窗
      
      addForm: {
        machineNo: '', // 机台选择
        transferOrderDate: '', // 计划下发时间
        isSort: false, // 排序置顶
        customerName: '', // 客户名称
        contractNo: '', // 合同号
        clothTypeNo: '', // 布种编号
        clothTypeName: '', // 布种名称
        zhiBuDanJia: '', // 织布单价
        jiJianDanJia: '', // 计件单价
        orderQuantity: '', // 下单条数
        requiredWeight: '', // 要求匹重
        orderWeight: '', // 下单重量
        deliveryDate: '', // 交货时间
        greyClothSheetNo: '', // 胚布指示单号
        customerStyleNo: '', // 客户款号
        remark: '', // 备注
        ztppZtgcpoiId: '' // 胚布指示单详情表ID
      },
      
      // 临时保存表单数据
      tempAddForm: {},

      
      // 客户列表相关
      customerList: [],
      customerLoading: false,
      customerListTotal: 0, // 客户列表总数
      customerPage: {
        pageNum: 1,
        pageSize: 10,
        customerName: ''
      },
      
      // 合同列表相关
      contractList: [],
      contractLoading: false,
      contractListTotal: 0, // 合同列表总数
      contractPage: {
        pageNum: 1,
        pageSize: 10
      },
      contractSearchParam: {
        customerName: '',
        ztgcpoContractNo: '',
        greyClothSheetNo: ''
      },
      
      // 客户表格列配置
      customerTableColumns: [
        {
          title: "客户名称",
          key: "ztgcpoCustomer",
          minWidth: 200
        }
      ],
      
      // 合同表格列配置
      contractTableColumns: [
        {
          title: "合同号",
          key: "ztgcpoContractNo",
          minWidth: 150
        },
        {
          title: "胚布指示单号",
          key: "greyClothSheetNo",
          width: 140
        },
        {
          title: "布种编号",
          key: "ztgcpoGreyClothItemNo",
          minWidth: 120
        },
        {
          title: "布种名称",
          key: "buZhongMingCheng",
          minWidth: 120
        },
        {
          title: "织布单价",
          key: "ztgcpoiPrice",
          width: 100
        },
        {
          title: "计件单价",
          key: "ztgcpoiMachinistLabourCost",
          width: 100
        },
        {
          title: "下单条数",
          key: "ztgcpoiClothNum",
          width: 100
        },
        {
          title: "要求匹重",
          key: "ztgcpoiClothWeight",
          width: 100
        },
        {
          title: "下单重量",
          key: "ztgcpoiPlanNum",
          width: 100
        },
        {
          title: "交货日期",
          key: "ztgcpoDeliveryDate",
          width: 120
        }
      ],

      addFormRules: {
        machineNo: [
          { required: true, message: '机台选择不能为空' }
        ],
        customerName: [
          { required: true, message: '客户名称不能为空' }
        ],
        contractNo: [
          { required: true, message: '合同号不能为空' }
        ]
      },

      greyClothPlanOrderInfo: {
        weaveDetail: "", // 胚布指示单号(织造明细)
        ztgcpoContractNo: "", // 合同号
        ztgcpoCustomer: "", // 客户名称
        ztgcpoiClientNum: "", // 客户款号
        ztgcpoGreyClothItemNo: "", // 胚布货号
        ztgcpoiClothWeight: 0, // 计划匹重
        ztgcpoiOrderDemandNum: 0, // 订单需求数
        ztgcpoiPlanNum: 0, // 计划数
        ztgcpoiClothNum: 0, // 计划匹数

        ztppTransferOrderDate: this.moment(new Date()).format("YYYY-MM-DD HH:mm:ss"), // 自动下发时间，形如 "2021-12-11 12:14:11"
        ztppPlanStartDate: "", // 预计开工日期，形如 "2021-12-11"
        ztppPlanEndDate: "", // 预计完工日期

        // ————————————————我是分割线——————————————

        // 纯前端用的数据源，与表单的交互组件依次绑定
        rawTransferOrderDate: null, // 对应 ztppTransferOrderDate
        rawPlanStartDate: null, // 对应 ztppPlanStartDate
        rawPlanEndDate: null, // 对应 ztppPlanEndDate

        // ————————————————我是分割线——————————————

        ztppMachineNoList: [
          {
            machineNo: "",
            transferOrderStatus: 3 // 3表示下发失败
          }
        ],

        ztppRemark: "", // 备注

        ztppId: 0, // 排产表id
        ztppPlanNum: 0, // 计划数(来自排产表) // 这2个字段先留着，后续可能会用到或者修改
        ztppClothNum: 0 // 计划匹数(来自排产表)
      },
      greyClothPlanOrderRule: {
        ztgcpoiClothNum: [
          {
            required: true,
            message: "计划匹数不能为空"
          }
        ],
        ztgcpoiPlanNum: [
          {
            required: true,
            message: "计划数不能为空"
          }
        ],
        ztppPlanStartDate: [
          {
            type: "date",
            required: true,
            message: "预计开工日期不能为空",
            trigger: "change"
          }
        ],
        ztppPlanEndDate: [
          {
            type: "date",
            required: true,
            message: "预计完工日期不能为空",
            trigger: "change"
          }
        ],
        ztppMachineNoList: [
          {
            type: "array",
            required: true,
            message: "选择机台不能为空",
            validator: (rule, value) => value.length > 0
          }
        ]
      },

      spinShow: false, // 排产弹窗获取数据时的加载状态

      // 机台弹窗的表格配置
      machineListParam: {
        param: {
          status: -1, // 状态（-1 全部，1 空闲， 2 在产）
          machineNo: "",
          greyClothItemNo: ""
        }
      },

      // 左侧机台侧边栏配置
      machineSidebarLoading: false,
      machineSidebarParam: {
        machineNo: ""
      },
      machineSidebarColumns: [
        {
          title: "机台号",
          key: "machineNo",
          width: 80
        },
        {
          title: "状态",
          key: "status",
          width: 80,
          render: (h, params) => {
            const statusMap = {
              空闲: 'status-idle',
              在产: 'status-working'
            };
            return h('span', { class: ['status-tag', statusMap[params.row.status]] }, params.row.status);
          }
        }
      ],
      machineSidebarData: [],
      selectedMachineNo: "", // 当前选中的机台号

      machineLoading: false,
      machineTableColumns: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: "机台号",
          key: "machineNo",
          minWidth: 120
        },
        {
          title: "设备类型",
          key: "deviceType",
          minWidth: 120
        },
        {
          title: "状态",
          key: "status",
          minWidth: 120
        },
        {
          title: "针寸数",
          key: "needleGauge",
          minWidth: 120
        },
        {
          title: "胚布货号",
          key: "greyClothItemNo",
          minWidth: 120
        },
        {
          title: "客户款号",
          key: "clientNum",
          minWidth: 120
        },
        {
          title: "预计完工日期",
          key: "maxDate",
          minWidth: 120
        }
      ],
      machineTableData: [],

      previousDeviceIdList: [], // 打开机台弹窗前，已有机台编号的数组
      selectedDeviceIdList: [], // 在机台弹窗内操作，最终所有已选择的机台编号的数组(包括 previousDeviceIdList)

      searchTypeList, // 首页——搜索类型的 Select 下拉框列表
      schedulingStatusList, // 首页——是否排产的 Select 下拉框列表
      deviceStatusList // 选择机台弹窗——设备状态的 Select 下拉框列表
    };
  },

  created() {
    this.getTableListData();
    this.getMachineSidebarList();
  },
  methods: {
    handleTransferOrderDateChange(formatDate, DateObj) {
      this.greyClothPlanOrderInfo.ztppTransferOrderDate = formatDate;
    },
    handlePlanStartDateChange(formatDate, DateObj) {
      this.greyClothPlanOrderInfo.ztppPlanStartDate = formatDate;
    },
    handlePlanEndDateChange(formatDate, DateObj) {
      this.greyClothPlanOrderInfo.ztppPlanEndDate = formatDate;
    },

    // 获取左侧机台列表
    getMachineSidebarList() {
      this.machineSidebarLoading = true;
      fetchDeviceList({
        param: {
          status: -1,
          machineNo: this.machineSidebarParam.machineNo,
          greyClothItemNo: ""
        }
      })
        .then(res => {
          if (res.data.success === 1) {
            this.machineSidebarData = res.data.body.deviceList;
          } else {
            this.$Message.error(res.data.msg);
          }
          this.machineSidebarLoading = false;
        })
        .catch(err => {
          console.log(err);
          this.machineSidebarLoading = false;
        });
    },

    // 点击机台列表行
    handleMachineRowClick(row) {
      this.selectedMachineNo = row.machineNo;
      this.listParam.machineNo = row.machineNo;
      this.getTableListData();
    },

    getTableListData() {
      this.loading = true;
      fetchProductPlanList(this.listParam)
        .then(res => {
          if (res.data.success === 1) {
            const { list } = res.data.body;

            // 表格中相应数据行设为多选禁用状态，（需禁用 1：待排产，3：量产中，4：指定完工）
            // for (let i = 0; i < list.list.length; i++) {
            //   const { status } = list.list[i];
            //   if (status === 1 || status === 3 || status === 4) {
            //     list.list[i]._disabled = true;
            //   }
            // }

            this.tableData = list.list;
            this.listDataTotal = list.total;

            this.loading = false;
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    getMachineTableListData() {
      this.machineLoading = true;
      fetchDeviceList(this.machineListParam)
        .then(res => {
          if (res.data.success === 1) {
            const { deviceList } = res.data.body;

            for (let i = 0; i < deviceList.length; i++) {
              for (let j = 0; j < this.previousDeviceIdList.length; j++) {
                if (deviceList[i].machineNo === this.previousDeviceIdList[j]) {
                  deviceList[i]._checked = true; // 默认加上之前已选中项的复选框
                  deviceList[i]._disabled = true; // 设置之前已选中项的复选框为禁用
                }
              }
            }

            this.machineTableData = deviceList;
          } else {
            this.$Message.error(res.data.msg);
          }
          this.machineLoading = false;
        })
        .catch(err => {
          console.log(err);
        });
    },

    pageSizeChange(pageSize) {
      this.listParam.pageSize = pageSize;
      this.listParam.pageNum = 1;
      this.getTableListData();
    },
    pageNumberChange(pageNum) {
      this.listParam.pageNum = pageNum;
      this.getTableListData();
    },



    // 同步表格数据
    syncTableData() {
      this.loading = true;
      fetchSyncTableData()
        .then(res => {
          if (res.data.success === 1) {
            this.$Message.success("同步成功！");
            this.getTableListData();
          } else {
            this.$Message.warning("同步失败！");
          }
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 删除排产计划
    cancelProduction() {
      if (this.ztppIdList.length <= 0) {
        this.$Message.warning("请至少选择一个排产计划");
        return;
      }

      this.$Modal.confirm({
        title: "确认删除",
        content: `确定要删除选中的 ${this.ztppIdList.length} 个排产计划吗？`,
        onOk: () => {
          fetchCancelProduction(this.ztppIdList)
            .then(res => {
              if (res.data.success === 1) {
                this.$Message.success("删除操作成功！");
                this.getTableListData();
              } else {
                this.$Message.error(res.data.msg);
              }
            })
            .catch(err => {
              console.log(err);
              this.$Message.error("删除操作失败，请重试");
            });
        }
      });
    },

    // 导出表格
    exportProductPlanList() {
      const { pageNum, pageSize, ...data } = this.listParam;
      const dataStr = this.qs.stringify(data);
      window.location.href = `${this.baseUrl}/dtsum/zongtong/order/ProductPlanController/productPlanExport?${dataStr}`;
    },

    // 重置搜索表单
    resetForm() {
      this.listParam = {
        searchType: 1, // 1:胚布指示单号,2:合同号,3:客户名称,4:款式（客户款号）
        searchText: "", // 根据searchType填写相应内容
        machineNo: "", // 机台号
        greyClothGoodsNo: "", // 胚布货号
        ifScheduling: 0,
        pageNum: 1,
        pageSize: 10
      };
      this.machineSidebarParam.machineNo = "";
      this.selectedMachineNo = "";
      this.getTableListData();
      this.getMachineSidebarList();
    },

    selectionChange(selection) {
      this.ztppIdList = selection
        .map(item => item.ztppId)
        .filter(id => id);
    },
    machineSelectionChange(selection) {
      // 先合并，再去重
      this.selectedDeviceIdList = Array.from(
        new Set([...this.previousDeviceIdList, ...selection.map(item => item.machineNo)])
      );
    },

    modalVisibleChange(isVisible) {
      this.$refs.greyClothPlanOrderFrom.resetFields();
    },

    subModalVisibleChange(isVisible) {
      if (!isVisible) {
        this.machineListParam = {
          param: {
            status: -1, // 状态（-1 全部，1 空闲， 2 在产）
            machineNo: "",
            greyClothItemNo: ""
          }
        };
      } else {
        this.previousDeviceIdList = this.greyClothPlanOrderInfo.ztppMachineNoList.map(
          item => item.machineNo
        );

        this.selectedDeviceIdList = [...this.previousDeviceIdList];
      }
    },

    // 跳转到对应的胚布指示单胚布生产查询详情页面
    goToDetailPage({ greyClothSheetNo }) {
      this.$router.push({
        path: "/workOrderManage/clothSheetDetail",
        query: { ztgcpoiWeaveDetail: greyClothSheetNo }
      });
    },

    // 排产弹窗的相关事件
    clickProductPlan({ ztgcpoiId, ztppId }, index, action) {
      this.currentRowIndex = index;
      this.isShowProductPlanModal = true;
      this.spinShow = true;

      fetchTransferOrderDetail({ ztgcpoiId, ztppId })
        .then(res => {
          if (res.data.success === 1) {
            const { greyClothPlanOrderInfo } = res.data.body;
            const {
              ztppTransferOrderDate,
              ztppPlanStartDate,
              ztppPlanEndDate
            } = greyClothPlanOrderInfo;

            if (action === "update") {
              this.greyClothPlanOrderInfo = {
                ...greyClothPlanOrderInfo,
                rawTransferOrderDate: ztppTransferOrderDate,
                rawPlanStartDate: ztppPlanStartDate,
                rawPlanEndDate: ztppPlanEndDate
              };
            } else {
              this.greyClothPlanOrderInfo = {
                ...greyClothPlanOrderInfo,
                rawTransferOrderDate: null,
                rawPlanStartDate: null,
                rawPlanEndDate: null
              };
            }
          } else {
            this.$Message.error(res.data.msg);
          }
          this.spinShow = false;
        })
        .catch(err => {
          console.log(err);
        });
    },

    clickSelectMachine() {
      this.isShowselectMachineModal = true;
      this.getMachineTableListData();
    },

    removeMachineTag(event, name) {
      const index = this.greyClothPlanOrderInfo.ztppMachineNoList
        .map(item => item.machineNo)
        .indexOf(name);
      this.greyClothPlanOrderInfo.ztppMachineNoList.splice(index, 1);
    },

    // 确定当前所选的机台编号，添加到总的设备编号列表中
    submitSelectMachine() {
      this.greyClothPlanOrderInfo.ztppMachineNoList = this.selectedDeviceIdList.map(item => ({
        machineNo: item,
        transferOrderStatus: 1 // 待下发，全这样处理，先不管
      }));

      // 暂时先注释，后面在说
      // for (let i = 0; i < this.previousDeviceIdList.length; i++) {
      //   const element = this.previousDeviceIdList[i];
      //   let isExist = false;
      //   this.greyClothPlanOrderInfo.ztppMachineNoList.forEach((item) => {
      //     if (item.machineNo === element) isExist = true;
      //   });

      //   if (!isExist) {
      //     this.greyClothPlanOrderInfo.ztppMachineNoList.push({
      //       machineNo: element,
      //     });
      //   }
      // }
    },

    submitProductPlan(formRef) {
      const {
        ztppMachineNoList: machines,
        ztppTransferOrderDate,
        ztppPlanStartDate,
        ztppPlanEndDate,
        ...otherParam
      } = this.greyClothPlanOrderInfo;
      const {
        ztppId,
        ztgcpoiPlanNum, // 计划数
        ztgcpoiClothNum, // 计划匹数
        ztppRemark
      } = otherParam;

      this.$refs[formRef].validate(valid => {
        if (valid) {
          if (
            ztppTransferOrderDate &&
            this.moment(ztppTransferOrderDate) <= this.moment(new Date())
          ) {
            // 计划下发时间(可选填)，若填写了，进行校验————只能填当前时间之后的时间
            this.$Message.warning("计划下发时间填写不规范，只能填写当前时间之后的时间日期！");
            return;
          }

          if (
            ztppPlanStartDate &&
            ztppPlanEndDate &&
            this.moment(ztppPlanEndDate) < this.moment(ztppPlanStartDate)
          ) {
            this.$Message.warning("预计完工日期不能早于预计开工日期！");
            return;
          }

          const ztppMachineNoList = machines.map(item => item.machineNo).join(",");
          fetchSubmitProductPlan({
            ztppId, // 排产表id
            ztppZtgcpoiId: this.tableData[this.currentRowIndex].ztgcpoiId, // 胚布指示单详情表ID
            ztppPlanNum: ztgcpoiPlanNum, // 计划数
            ztppClothNum: ztgcpoiClothNum, // 计划匹数
            ztppTransferOrderDate, // (自动)下发时间
            ztppPlanStartDate, // 预计开工日期
            ztppPlanEndDate, // 预计完工日期
            ztppMachineNoList, // 机台号列表  形如 字符串 "1,3,4,5,6"
            ztppRemark // 备注
          })
            .then(res => {
              if (res.data.success === 1) {
                this.$Message.success("提交排产计划成功！");
                this.getTableListData();
                this.isShowProductPlanModal = false;
              } else {
                this.$Message.error(res.data.msg);
              }
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          this.$Message.warning("请填写完整的表单数据！");
        }
      });
    },

    bindFailRowClass(row, index) {
      // 本页面用不到，暂时注释该方法
      // // 下发失败，有机台未下发成功，为表格中相应的行，添加背景颜色
      // const { transferOrderStatus } = row;
      // if (transferOrderStatus === 1) {
      //   return "row-status-fail";
      // }
    },

    checkOvertime(date) {
      // date 时间字符串格式 "2021-07-21"
      if (!date) return false;

      const currentDate = new Date().setHours(0, 0, 0, 0);
      const planDate = new Date(date).setHours(0, 0, 0, 0);

      // 同一天不算超时
      if (currentDate > planDate) {
        return true;
      } else {
        return false;
      }
    },

    // 打开新增弹窗
    openAddModal() {
      // 重置表单数据
      this.addModalTitle = '新增排产';

      this.addForm = {
        machineNo: '', // 机台选择
        transferOrderDate: '', // 计划下发时间
        isSort: false, // 排序置顶
        customerName: '', // 客户名称
        contractNo: '', // 合同号
        clothTypeNo: '', // 布种编号
        clothTypeName: '', // 布种名称
        zhiBuDanJia: '', // 织布单价
        jiJianDanJia: '', // 计件单价
        orderQuantity: '', // 下单条数
        requiredWeight: '', // 要求匹重
        orderWeight: '', // 下单重量
        deliveryDate: '', // 交货时间
        greyClothSheetNo: '', // 胚布指示单号
        customerStyleNo: '', // 客户款号
        remark: '', // 备注
        ztppZtgcpoiId: '' // 胚布指示单详情表ID
      };
      this.isShowAddModal = true;
    },

    // 打开修改弹窗
    openEditModal(row, index) {
      // 设置弹窗标题
      this.addModalTitle = '修改排产';
      // 打印调试信息
  console.log('Row data:', row);
  console.log('zhiBuDanJia:', row.zhiBuDanJia);
  console.log('jiJianDanJia:', row.jiJianDanJia);
  console.log('deliveryDate:', row.deliveryDate);
      // 填充表单数据
      this.addForm = {
        machineNo: row.machineNo || '', // 机台选择
        transferOrderDate: row.transferOrderDate || '', // 计划下发时间
        isSort: false, // 排序置顶
        customerName: row.clientName || '', // 客户名称
        contractNo: row.contractNo || '', // 合同号
        clothTypeNo: row.buZhongBianHao || '', // 布种编号
        clothTypeName: row.buZhongMingCheng || '', // 布种名称
        zhiBuDanJia: row.zhiBuDanJia || '0', // 织布单价
        jiJianDanJia: row.jiJianDanJia || '0', // 计件单价
        orderQuantity: row.xiaDanTiaoShu || '', // 下单条数
        requiredWeight: row.yaoQiuPiZhong || '', // 要求匹重
        orderWeight: row.xiaDanZhonLiang || '', // 下单重量
        deliveryDate: (row.deliveryDate || row.JiaoHuoShiJian) ? (row.deliveryDate || row.JiaoHuoShiJian) + ' 00:00' : '', // 交货时间
        greyClothSheetNo: row.greyClothSheetNo || '', // 胚布指示单号
        customerStyleNo: row.keHuKuanHao || '', // 客户款号
        remark: row.remark || '', // 备注
        ztppZtgcpoiId: row.ztgcpoiId || '', // 胚布指示单详情表ID
        ztppId: row.ztppId || '' // 排产表id
      };
      console.log('addForm:', this.addForm);
      this.isShowAddModal = true;
    },

    // 新增弹窗显示/隐藏时的回调
    addModalVisibleChange(isVisible) {
      // 不重置表单数据，保留之前填写的数据
      // 只有在用户手动关闭弹窗时才重置
    },

    // 保存新增表单
    saveAddForm(type) {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          // 从localStorage中获取用户信息
          const userInfo = localStorage.getItem('userInfo');
          let userId = '';
          if (userInfo) {
            const user = JSON.parse(userInfo);
            if (user.userId) {
              userId = user.userId;
            }
          }
          
          // 准备API请求参数
          const params = {
            ztppClothNum: this.addForm.orderQuantity, // 计划匹数
            ztppPlanNum: this.addForm.orderWeight, // 计划数
            ztppMachineNoList: this.addForm.machineNo, // 机台号
            ztppPlanEndDate: this.addForm.deliveryDate, // 预计完工日期（使用交货时间）
            ztppPlanStartDate: this.addForm.transferOrderDate, // 预计开工日期（使用计划下发时间）
            ztppTransferOrderDate: this.addForm.transferOrderDate, // 计划下发时间
            ztppRemark: this.addForm.remark, // 备注
            ztppZtgcpoiId: this.addForm.ztppZtgcpoiId, // 胚布指示单详情表ID
            xiaFa: type === 'saveAndSend' ? '1' : '', // 下发状态（1:下发并且保存,其他值：只会保存）
            
          };
          if (this.addModalTitle === '修改排产'){
            params.ztppId = this.addForm.ztppId;
          }
          
          // 调用API保存数据
          fetchSubmitProductPlan(params)
            .then(res => {
              if (res.data.success === 1) {
                this.$Message.success(type === 'add' ? '保存成功！' : '保存并下发成功！');
                this.isShowAddModal = false;
                this.getTableListData();
              } else {
                this.$Message.error(res.data.msg);
              }
            })
            .catch(err => {
              console.log(err);
              this.$Message.error('保存失败，请重试');
            });
        } else {
          this.$Message.warning('请填写完整的表单数据！');
        }
      });
    },

    // 打开新增排产的机台选择弹窗
    openMachineSelectModal() {
      console.log('打开新增排产的机台选择弹窗');
      // 保存当前表单数据
      this.tempAddForm = { ...this.addForm };
      // 隐藏新增排产弹窗
      this.isShowAddModal = false;
      this.isShowAddMachineModal = true;
      this.getMachineTableListData();
    },

    // 选择机台后确认
    submitAddMachineSelect() {
      if (this.selectedDeviceIdList.length > 0) {
        // 恢复表单数据
        this.addForm = { ...this.tempAddForm };
        this.addForm.machineNo = this.selectedDeviceIdList.filter(id => id).join(',');
        this.isShowAddMachineModal = false;
        // 显示新增排产弹窗
        this.isShowAddModal = true;
      } else {
        this.$Message.warning('请至少选择一个机台');
      }
    },

    // 打开客户选择弹窗
    openCustomerSelectModal() {
      // 保存当前表单数据
      this.tempAddForm = { ...this.addForm };
      // 隐藏新增排产弹窗
      this.isShowAddModal = false;
      this.customerPage.pageNum = 1;
      this.isShowCustomerModal = true;
      this.searchCustomer(''); // 加载客户列表
    },

    // 客户列表分页大小改变
    customerPageSizeChange(pageSize) {
      this.customerPage.pageSize = pageSize;
      this.searchCustomer(this.customerPage.customerName);
    },

    // 客户列表页码改变
    customerPageNumberChange(pageNum) {
      this.customerPage.pageNum = pageNum;
      this.customerLoading = true;
      fetchCustomerSearch({
        pageSize: this.customerPage.pageSize,
        pageNum: this.customerPage.pageNum,
        customerName: this.customerPage.customerName
      })
      .then(res => {
        if (res.data.success === 1) {
          this.customerList = res.data.body.customerList.list;
        } else {
          this.$Message.error(res.data.msg);
        }
        this.customerLoading = false;
      })
      .catch(err => {
        console.log(err);
        this.customerLoading = false;
      });
    },

    // 选择客户后确认
    submitCustomerSelect(customer) {
      // 恢复表单数据
      this.addForm = { ...this.tempAddForm };
      this.addForm.customerName = customer.ztgcpoCustomer;
      this.addForm.contractNo = ''; // 清空合同号
      this.isShowCustomerModal = false;
      // 显示新增排产弹窗
      this.isShowAddModal = true;
    },

    // 打开合同号选择弹窗
    openContractSelectModal() {
      if (!this.addForm.customerName) {
        this.$Message.warning('请先选择客户');
        return;
      }
      // 保存当前表单数据
      this.tempAddForm = { ...this.addForm };
      // 隐藏新增排产弹窗
      this.isShowAddModal = false;
      this.isShowContractModal = true;
      this.searchContract(this.addForm.customerName); // 加载合同列表
    },

    // 选择合同后确认
    submitContractSelect(contract) {
      // 恢复表单数据
      this.addForm = { ...this.tempAddForm };
      this.addForm.contractNo = contract.ztgcpoContractNo;
      // 自动填充其他字段
      this.addForm.clothTypeNo = contract.ztgcpoGreyClothItemNo;
      this.addForm.clothTypeName = contract.buZhongMingCheng;
      this.addForm.zhiBuDanJia = contract.ztgcpoiPrice;
      this.addForm.jiJianDanJia = contract.ztgcpoiMachinistLabourCost;
      this.addForm.orderQuantity = contract.ztgcpoiClothNum;
      this.addForm.requiredWeight = contract.ztgcpoiClothWeight;
      this.addForm.orderWeight = contract.ztgcpoiPlanNum;
      // 处理交货时间，确保格式正确
      if (contract.ztgcpoDeliveryDate) {
        // 如果是日期字符串，转换为正确的格式
        const date = new Date(contract.ztgcpoDeliveryDate);
        if (!isNaN(date.getTime())) {
          // 格式化为 yyyy-MM-dd HH:mm
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          this.addForm.deliveryDate = `${year}-${month}-${day} ${hours}:${minutes}`;
        } else {
          // 如果不是有效的日期，直接使用原始值
          this.addForm.deliveryDate = contract.ztgcpoDeliveryDate;
        }
      } else {
        this.addForm.deliveryDate = '';
      }
      this.addForm.greyClothSheetNo = contract.greyClothSheetNo;
      this.addForm.customerStyleNo = contract.clientMoneyNo;
      this.addForm.ztppZtgcpoiId = contract.ztgcpoiId; // 保存胚布指示单详情表ID
      this.isShowContractModal = false;
      // 显示新增排产弹窗
      this.isShowAddModal = true;
    },

    // 搜索客户
    searchCustomer(query) {
      this.customerPage.pageNum = 1;
      this.customerPage.customerName = query || '';
      this.customerLoading = true;
      fetchCustomerSearch({
        pageSize: this.customerPage.pageSize,
        pageNum: this.customerPage.pageNum,
        customerName: this.customerPage.customerName
      })
      .then(res => {
        if (res.data.success === 1) {
          this.customerList = res.data.body.customerList.list;
          this.customerListTotal = res.data.body.customerList.total;
        } else {
          this.$Message.error(res.data.msg);
        }
        this.customerLoading = false;
      })
      .catch(err => {
        console.log(err);
        this.customerLoading = false;
      });
    },

    // 搜索合同
    searchContract() {
      this.contractPage.pageNum = 1;
      this.contractLoading = true;
      fetchContractNoByCustomerName({
        pageSize: this.contractPage.pageSize,
        pageNum: this.contractPage.pageNum,
        customerName: this.addForm.customerName,
        ztgcpoContractNo: this.contractSearchParam.ztgcpoContractNo,
        greyClothSheetNo: this.contractSearchParam.greyClothSheetNo
      })
      .then(res => {
          if (res.data.success === 1) {
            this.contractList = res.data.body.contractNoByCustomerNameList.list;
            this.contractListTotal = res.data.body.contractNoByCustomerNameList.total;
          } else {
            this.$Message.error(res.data.msg);
          }
          this.contractLoading = false;
        })
      .catch(err => {
        console.log(err);
        this.contractLoading = false;
      });
    },

    // 重置合同搜索
    resetContractSearch() {
      this.contractSearchParam = {
        ztgcpoContractNo: '',
        greyClothSheetNo: ''
      };
      this.searchContract();
    },

    // 合同列表分页大小改变
    contractPageSizeChange(pageSize) {
      this.contractPage.pageSize = pageSize;
      this.searchContract();
    },

    // 合同列表页码改变
    contractPageNumberChange(pageNum) {
      this.contractPage.pageNum = pageNum;
      this.contractLoading = true;
      fetchContractNoByCustomerName({
        pageSize: this.contractPage.pageSize,
        pageNum: this.contractPage.pageNum,
        customerName: this.addForm.customerName,
        ztgcpoContractNo: this.contractSearchParam.ztgcpoContractNo,
        greyClothSheetNo: this.contractSearchParam.greyClothSheetNo
      })
      .then(res => {
        if (res.data.success === 1) {
          this.contractList = res.data.body.contractNoByCustomerNameList.list;
        } else {
          this.$Message.error(res.data.msg);
        }
        this.contractLoading = false;
      })
      .catch(err => {
        console.log(err);
        this.contractLoading = false;
      });
    }


  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/css/common.scss";

// 表格下面的分页器部分
.page {
  margin-top: 10px;
  text-align: center;
}

// 排产模态框
.modal-container-product-plan {
  .top {
    margin-bottom: 20px;
  }
}

// 机台模态框
.select-machine-modal {
  .selectedMachineRow {
    background-color: #f9f9f9;
    margin: 20px 0;
    padding: 10px;
    z-index: 100 !important;
  }
}
.add-machine-modal {
  z-index: 2000 !important;
}
.product-plan-modal {
  .ivu-tag {
    background-color: #fff;
    border: 1px #57a3f3 solid;
  }

  .tag-fail {
    background: rgba(249, 64, 64, 0.3);
    border: 1px #f94040 solid;
  }
}

#page-product-plan {
  .ivu-table .row-status-fail td {
    background-color: rgba(249, 64, 64, 0.1);
  }

  .main-content {
    display: flex;
    gap: 20px;
    min-width: 100%;
  }

  .machine-sidebar {
    width: 220px;
    flex-shrink: 0;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    padding: 16px;
    display: flex;
    flex-direction: column;
    max-height: calc(100vh - 120px);
    overflow-y: auto;
  }

  .machine-search {
    margin-bottom: 16px;
    flex-shrink: 0;
  }

  .right-content {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
  }

  .right-content .common-filter-block,
  .right-content .common-action-block {
    flex-shrink: 0;
  }

  .right-content .ivu-table-wrapper {
    overflow-x: auto;
  }

  .status-tag {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
  }

  .status-idle {
    background-color: #f0f9eb;
    color: #67c23a;
  }

  .status-working {
    background-color: #fff7e6;
    color: #e6a23c;
  }
}

/* 伪输入框样式 */
.pseudo-input {
  width: 100%;
  height: 32px;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: border-color 0.2s;
  overflow: hidden;
  
  &:hover {
    border-color: #57a3f3;
  }
  
  &.disabled {
    cursor: not-allowed;
    background-color: #f5f7fa;
    
    &:hover {
      border-color: #dcdee2;
    }
  }
  
  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
  }
  
  .placeholder {
    color: #999;
  }
  
  i {
    color: #999;
    font-size: 12px;
  }
}
</style>
